import { css } from "@stubhub/broadway-foundation/css";

// Gradient blob — percentage-based positioning so it adapts to any viewport width.
// Blob is ~45% of container width (177/390 from Figma), centered horizontally.
export const modalCardClass = css({
  position: "relative",
  overflowX: "hidden",
  overflowY: "hidden",
  "&::before": {
    content: "['']",
    position: "absolute",
    width: "[45%]",
    height: "[454px]",
    insetInlineStart: "[27.5%]",
    insetBlockStart: "[-80px]",
    backgroundImage:
      "[conic-gradient(from 180deg at 50% 50%, rgba(94,41,186,0.20) 0deg, rgba(221,30,117,0.20) 180deg, rgba(94,41,186,0.20) 360deg)]",
    opacity: "[0.6]",
    filter: "[blur(50px)]",
    transform: "[rotate(-71.73deg)]",
    pointerEvents: "none",
    zIndex: "[0]",
  },
});

export const bodyStyle = css({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "full",
  textAlign: "center",
  zIndex: "[1]",
});

// Rating group container: left card (-15deg) | center icon (100×100) | right card (+15deg)
// Figma: cards top:5px, icon top:14px → container height = 14 + 100 = 114px + rotation overflow
export const ratingGroupStyle = css({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "[130px]",
  width: "[255px]",
});

// Left card: 4.8 + stars, rotation -15deg, Figma: top 24px
export const leftCardStyle = css({
  position: "absolute",
  insetInlineStart: "[0]",
  insetBlockStart: "[24px]",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  columnGap: "[2px]",
  rowGap: "[2px]",
  backgroundColor: "[#F6ECFF]",
  borderStartStartRadius: "[13px]",
  borderStartEndRadius: "[13px]",
  borderEndEndRadius: "[13px]",
  borderEndStartRadius: "[13px]",
  paddingBlockStart: "[10px]",
  paddingInlineEnd: "[10px]",
  paddingBlockEnd: "[10px]",
  paddingInlineStart: "[10px]",
  boxShadow: "[0px 6px 17px rgba(0,0,0,0.07)]",
  transform: "[rotate(-15deg)]",
  width: "[80px]",
  height: "[80px]",
});

// Right card: "1.4m+" + "Ratings", rotation +15deg, Figma: top 24px
export const rightCardStyle = css({
  position: "absolute",
  insetInlineEnd: "[0]",
  insetBlockStart: "[24px]",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  columnGap: "[2px]",
  rowGap: "[2px]",
  backgroundColor: "[#F6ECFF]",
  borderStartStartRadius: "[13px]",
  borderStartEndRadius: "[13px]",
  borderEndEndRadius: "[13px]",
  borderEndStartRadius: "[13px]",
  paddingBlockStart: "[10px]",
  paddingInlineEnd: "[10px]",
  paddingBlockEnd: "[10px]",
  paddingInlineStart: "[10px]",
  boxShadow: "[0px 6px 17px rgba(0,0,0,0.07)]",
  transform: "[rotate(15deg)]",
  width: "[80px]",
  height: "[80px]",
});

// "1.4m+" text inside right card
export const ratingsCountStyle = css({
  fontWeight: "[600]",
  fontSize: "[18px]",
  lineHeight: "[1]",
  color: "[#5E29BA]",
  textAlign: "center",
});

export const ratingsLabelStyle = css({
  fontSize: "[10px]",
  lineHeight: "[14px]",
  color: "[#5E29BA]",
  textAlign: "center",
  fontWeight: "[500]",
});

// Center app icon: 100×100, Figma: top 0, z-index above both cards
export const appIconStyle = css({
  position: "absolute",
  insetInlineStart: "[50%]",
  insetBlockStart: "[0]",
  transform: "[translateX(-50%)]",
  width: "[100px]",
  height: "[100px]",
  borderStartStartRadius: "[16px]",
  borderStartEndRadius: "[16px]",
  borderEndEndRadius: "[16px]",
  borderEndStartRadius: "[16px]",
  objectFit: "cover",
  zIndex: "[1]",
});

// "4.8" — SemiBold 24px, purple
export const ratingScoreStyle = css({
  fontWeight: "[600]",
  fontSize: "[24px]",
  lineHeight: "[1]",
  color: "[#5E29BA]",
});

export const ratingStarsStyle = css({
  display: "flex",
  flexDirection: "row",
  columnGap: "[1px]",
  rowGap: "[1px]",
  color: "[#5E29BA]",
});

// Heading margin: primitives.100 gap after rating group, primitives.50 before button
export const headingStyle = css({
  marginBlockStart: "primitives.100",
  marginBlockEnd: "primitives.50",
});

// CTA button: full-width, black background via ButtonKind.Neutral
export const ctaButtonStyle = css({
  width: "full",
});

// CTA footer: extra top/bottom padding per Figma
export const ctaFooterStyle = css({
  paddingBlockStart: "primitives.300",
  paddingBlockEnd: "primitives.300",
});

// Arrow icon wrapper — spacing between CTA text and arrow
export const ctaArrowStyle = css({
  marginInlineStart: "[6px]",
  verticalAlign: "middle",
  display: "inline-flex",
});
